import brandInfoAll1 from "./1.js";
import brandInfoAll2 from "./2.js";
import brandInfoAll3 from "./3.js";
import brandInfoAll4 from "./4.js";
import brandInfoAll5 from "./5.js";
import brandInfoAll9 from "./9.js";
import brandInfoAll10 from "./10.js";
import brandInfoAll11 from "./11.js";
export default{
    brand1:brandInfoAll1.brandInfoAll,
    brand2:brandInfoAll2.brandInfoAll,
    brand3:brandInfoAll3.brandInfoAll,
    brand4:brandInfoAll4.brandInfoAll,
    brand5:brandInfoAll5.brandInfoAll,
    brand9:brandInfoAll9.brandInfoAll,
    brand10:brandInfoAll10.brandInfoAll,
    brand11:brandInfoAll11.brandInfoAll
}


// WEBPACK FOOTER //
// ./src/data/brand/index.js